import styled from 'styled-components';

import { StyledTabs as BaseStyledTabs, StyledTab as BaseStyledTab } from 'components/Tabs/styles';

/** Full height so the tab body's `flex: 1` has space to claim and the composer pins to the bottom. */
export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const HeaderContainer = styled.div`
  padding: 10px 16px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
`;

export const QuestionHeader = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
  /* This used to be the one-line Question 2.1; an unbounded label would move the tabs. */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-width: 0;
`;

export const StyledTabs = styled(BaseStyledTabs)`
  margin-bottom: 0;
  border-bottom: none;

  .MuiTabs-scroller {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
  }

  button {
    padding: 9px 16px;
  }
  > *:first-child {
    padding-left: 16px;
  }
`;

export const StyledTab = styled(BaseStyledTab)`
  min-height: unset;
`;

export const TabBody = styled.div`
  padding: 8px 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const Composer = styled.div`
  flex-shrink: 0;
  margin-top: 12px;
`;

export const EmptyState = styled.p`
  margin: 24px 0;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 20px;
`;

export const EmptyTabState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 24px 0;

  p {
    margin: 0;
    text-align: center;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  }
`;

export const RetryRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const InlineError = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  line-height: 16px;
`;
